// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/*!
 * jQuery contextMenu - Plugin for simple contextMenu handling
 *
 * Version: 1.5.24
 *
 * Authors: Rodney Rehm, Addy Osmani (patches for FF)
 * Web: http://medialize.github.com/jQuery-contextMenu/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *   GPL v3 http://opensource.org/licenses/GPL-3.0
 *
 */
.context-menu-list {
    margin:0;
    padding:0;

    min-width: 120px;
    max-width: 250px;
    display: inline-block;
    position: absolute;
    list-style-type: none;

    border: 1px solid #DDD;
    background: #EEE;

    -webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
       -moz-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
        -ms-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
         -o-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);

    font-family: Verdana, Arial, Helvetica, sans-serif;
    font-size: 11px;
}

.context-menu-item {
    padding: 2px 2px 2px 24px;
    background-color: #EEE;
    position: relative;
    -webkit-user-select: none;
       -moz-user-select: -moz-none;
        -ms-user-select: none;
            user-select: none;
}

.context-menu-separator {
    padding-bottom:0;
    border-bottom: 1px solid #DDD;
}

.context-menu-item > label > input,
.context-menu-item > label > textarea {
    -webkit-user-select: text;
       -moz-user-select: text;
        -ms-user-select: text;
            user-select: text;
}

.context-menu-item.hover {
    cursor: pointer;
    background-color: #39F;
}

.context-menu-item.disabled {
    color: #666;
}

.context-menu-input.hover,
.context-menu-item.disabled.hover {
    cursor: default;
    background-color: #EEE;
}

.context-menu-submenu:after {
    content: ">";
    color: #666;
    position: absolute;
    top: 0;
    right: 3px;
    z-index: 1;
}

/* icons
    #protip:
    In case you want to use sprites for icons (which I would suggest you do) have a look at
    http://css-tricks.com/13224-pseudo-spriting/ to get an idea of how to implement
    .context-menu-item.icon:before {}
 */
.context-menu-item.icon { min-height: 18px; background-repeat: no-repeat; background-position: 4px 2px; }

/* vertically align inside labels */
.context-menu-input > label > * { vertical-align: top; }

/* position checkboxes and radios as icons */
.context-menu-input > label > input[type="checkbox"],
.context-menu-input > label > input[type="radio"] {
    margin-left: -17px;
}
.context-menu-input > label > span {
    margin-left: 5px;
}

.context-menu-input > label,
.context-menu-input > label > input[type="text"],
.context-menu-input > label > textarea,
.context-menu-input > label > select {
    display: block;
    width: 100%;

    -webkit-box-sizing: border-box;
       -moz-box-sizing: border-box;
        -ms-box-sizing: border-box;
         -o-box-sizing: border-box;
            box-sizing: border-box;
}

.context-menu-input > label > textarea {
    height: 100px;
}
.context-menu-item > .context-menu-list {
    display: none;
    /* re-positioned by js */
    right: -5px;
    top: 5px;
}

.context-menu-item.hover > .context-menu-list {
    display: block;
}

.context-menu-accesskey {
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/css/contextmenu.css"],"names":[],"mappings":";;AAEA;;;;;;;;;;;;EAYE;AACF;IACI,QAAQ;IACR,SAAS;;IAET,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;;IAErB,sBAAsB;IACtB,gBAAgB;;IAEhB,gDAAgD;OAC7C,6CAA6C;QAC5C,4CAA4C;SAC3C,2CAA2C;YACxC,wCAAwC;;IAEhD,kDAAkD;IAClD,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;OACtB,2BAA2B;QAC1B,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;;IAEI,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,UAAU;AACd;;AAEA;;;;;EAKE;AACF,0BAA0B,gBAAgB,EAAE,4BAA4B,EAAE,4BAA4B,EAAE;;AAExG,mCAAmC;AACnC,kCAAkC,mBAAmB,EAAE;;AAEvD,4CAA4C;AAC5C;;IAEI,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;;AAEA;;;;IAII,cAAc;IACd,WAAW;;IAEX,8BAA8B;OAC3B,2BAA2B;QAC1B,0BAA0B;SACzB,yBAAyB;YACtB,sBAAsB;AAClC;;AAEA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,wBAAwB;IACxB,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":["\r\n\r\n/*!\r\n * jQuery contextMenu - Plugin for simple contextMenu handling\r\n *\r\n * Version: 1.5.24\r\n *\r\n * Authors: Rodney Rehm, Addy Osmani (patches for FF)\r\n * Web: http://medialize.github.com/jQuery-contextMenu/\r\n *\r\n * Licensed under\r\n *   MIT License http://www.opensource.org/licenses/mit-license\r\n *   GPL v3 http://opensource.org/licenses/GPL-3.0\r\n *\r\n */\r\n.context-menu-list {\r\n    margin:0;\r\n    padding:0;\r\n\r\n    min-width: 120px;\r\n    max-width: 250px;\r\n    display: inline-block;\r\n    position: absolute;\r\n    list-style-type: none;\r\n\r\n    border: 1px solid #DDD;\r\n    background: #EEE;\r\n\r\n    -webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);\r\n       -moz-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);\r\n        -ms-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);\r\n         -o-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);\r\n            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);\r\n\r\n    font-family: Verdana, Arial, Helvetica, sans-serif;\r\n    font-size: 11px;\r\n}\r\n\r\n.context-menu-item {\r\n    padding: 2px 2px 2px 24px;\r\n    background-color: #EEE;\r\n    position: relative;\r\n    -webkit-user-select: none;\r\n       -moz-user-select: -moz-none;\r\n        -ms-user-select: none;\r\n            user-select: none;\r\n}\r\n\r\n.context-menu-separator {\r\n    padding-bottom:0;\r\n    border-bottom: 1px solid #DDD;\r\n}\r\n\r\n.context-menu-item > label > input,\r\n.context-menu-item > label > textarea {\r\n    -webkit-user-select: text;\r\n       -moz-user-select: text;\r\n        -ms-user-select: text;\r\n            user-select: text;\r\n}\r\n\r\n.context-menu-item.hover {\r\n    cursor: pointer;\r\n    background-color: #39F;\r\n}\r\n\r\n.context-menu-item.disabled {\r\n    color: #666;\r\n}\r\n\r\n.context-menu-input.hover,\r\n.context-menu-item.disabled.hover {\r\n    cursor: default;\r\n    background-color: #EEE;\r\n}\r\n\r\n.context-menu-submenu:after {\r\n    content: \">\";\r\n    color: #666;\r\n    position: absolute;\r\n    top: 0;\r\n    right: 3px;\r\n    z-index: 1;\r\n}\r\n\r\n/* icons\r\n    #protip:\r\n    In case you want to use sprites for icons (which I would suggest you do) have a look at\r\n    http://css-tricks.com/13224-pseudo-spriting/ to get an idea of how to implement\r\n    .context-menu-item.icon:before {}\r\n */\r\n.context-menu-item.icon { min-height: 18px; background-repeat: no-repeat; background-position: 4px 2px; }\r\n\r\n/* vertically align inside labels */\r\n.context-menu-input > label > * { vertical-align: top; }\r\n\r\n/* position checkboxes and radios as icons */\r\n.context-menu-input > label > input[type=\"checkbox\"],\r\n.context-menu-input > label > input[type=\"radio\"] {\r\n    margin-left: -17px;\r\n}\r\n.context-menu-input > label > span {\r\n    margin-left: 5px;\r\n}\r\n\r\n.context-menu-input > label,\r\n.context-menu-input > label > input[type=\"text\"],\r\n.context-menu-input > label > textarea,\r\n.context-menu-input > label > select {\r\n    display: block;\r\n    width: 100%;\r\n\r\n    -webkit-box-sizing: border-box;\r\n       -moz-box-sizing: border-box;\r\n        -ms-box-sizing: border-box;\r\n         -o-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n}\r\n\r\n.context-menu-input > label > textarea {\r\n    height: 100px;\r\n}\r\n.context-menu-item > .context-menu-list {\r\n    display: none;\r\n    /* re-positioned by js */\r\n    right: -5px;\r\n    top: 5px;\r\n}\r\n\r\n.context-menu-item.hover > .context-menu-list {\r\n    display: block;\r\n}\r\n\r\n.context-menu-accesskey {\r\n    text-decoration: underline;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
